module.exports = __webpack_public_path__ + "static/img/lunbo2.b42eb16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/desktop/lunbo2.jpg
// module id = DUQ8
// module chunks = 15